<div class="layout-row place-start-center">
  @for (indicator of indicators$ | async; track indicator) {
    <mat-icon [color]="getColor(indicator.type)">
      {{ indicator.icon }}
    </mat-icon>
  }
</div>
